import PropTypes from 'prop-types';
import React from 'react';
import { Spinner } from '@99designs/common/components/Spinner';

const OverviewMenu = ({ heading, summaryAmount, children, isUpdating }) => (
    <div role="menu" className="overview-menu">
        <div className="overview-menu__heading">
            <div className="heading heading--h4 heading--no-margin">{heading}</div>
        </div>

        <ul className="overview-menu__list">{children}</ul>

        <div className="overview-menu__summary">
            {isUpdating ? (
                <Spinner variations={['small', 'inline']} />
            ) : (
                renderSummary(summaryAmount)
            )}
        </div>
    </div>
);

OverviewMenu.propTypes = {
    heading: PropTypes.node.isRequired,
    summaryAmount: PropTypes.node,
    isUpdating: PropTypes.bool,
};

OverviewMenu.defaultProps = {
    summaryAmount: null,
    isUpdating: false,
};

function renderSummary(summaryAmount) {
    return <div className="heading heading--h4 heading--no-margin">{summaryAmount}</div>;
}

export default OverviewMenu;
